import { useMemo } from 'react'
import { IntegrationServiceId } from '../../../../common/integrations'
import { ClickNavigationSection } from '../../../../components/NavigationWithSideBar/ClickNavigation'
import { AdvisorEngineSpecificSettings } from './AdvisorEngine/AdvisorEngineSpecificSettings'
import { DelegatedEmailSpecificSettings } from './DelegatedEmail/DelegatedEmailSpecificSettings'
import { DynamicsBasedSpecificSettings } from './DynamicsBased/DynamicsBasedSpecificSettings'
import { EMoneySpecificSettings } from './eMoney/EMoneySpecificSettings'
import { HubSpotSpecificSettings } from './Hubspot/HubspotSpecificSettings'
import { OrionSpecificSettings } from './Orion/OrionSpecificSettings'
import { PhoneSpecificSettings } from './Phone/PhoneSpecificSettings'
import { PreciseFPSpecificSettings } from './PreciseFP/PreciseFPSpecificSettings'
import { RedtailSpecificSettings } from './Redtail/RedtailSpecificSettings'
import { RightCapitalSpecificSettings } from './RightCapital/RightCapitalSpecificSettings'
import { RingCentralSpecificSettings } from './RingCentral/RingCentralSpecificSettings'
import { GoToSpecificSettings } from './GoTo/GoToSpecificSettings'
import { SalesforceBasedSpecificSettings } from './SalesforceBased/SalesforceBasedSpecificSettings'
import { SmartOfficeSpecificSettings } from './SmartOffice/SmartOfficeSpecificSettings'
import { WealthboxSpecificSettings } from './Wealthbox/WealthboxSpecificSettings'
import { ZohoSpecificSettings } from './Zoho/ZohoSpecificSettings'
import { useZoomSettingsSections } from './Zoom/hooks'
import { WealthSpecificSettings } from './Wealth/WealthSpecificSettings'
import { BlackDiamondWPSpecificSettings } from './BlackDiamondWP/BlackDiamondWPSpecificSettings'
import { SchwabSpecificSettings } from './Schwab/SchwabSpecificSettings'
// import { BoxSpecificSettings } from './Box/BoxSpecificSettings'

export const useIntegrationSpecificSettings = (serviceId: IntegrationServiceId): ClickNavigationSection[] => {
  const zoomSections = useZoomSettingsSections()

  return useMemo(() => {
    switch (serviceId) {
      case IntegrationServiceId.SALESFORCE:
      case IntegrationServiceId.PRACTIFI:
      case IntegrationServiceId.XLR8:
      case IntegrationServiceId.BLACK_DIAMOND:
      case IntegrationServiceId.ELEMENTS:
        return SalesforceBasedSpecificSettings(serviceId)
      case IntegrationServiceId.WEALTHBOX:
        return WealthboxSpecificSettings()
      case IntegrationServiceId.REDTAIL:
        return RedtailSpecificSettings()
      case IntegrationServiceId.HUBSPOT:
        return HubSpotSpecificSettings()
      case IntegrationServiceId.ZOHO:
        return ZohoSpecificSettings()
      case IntegrationServiceId.DYNAMICS:
      case IntegrationServiceId.ENGAGE:
        return DynamicsBasedSpecificSettings(serviceId)
      case IntegrationServiceId.SMARTOFFICE:
        return SmartOfficeSpecificSettings()
      case IntegrationServiceId.ADVISOR_ENGINE:
        return AdvisorEngineSpecificSettings()
      case IntegrationServiceId.PRECISE_FP:
        return PreciseFPSpecificSettings()
      case IntegrationServiceId.ORION:
        return OrionSpecificSettings()
      case IntegrationServiceId.BLACK_DIAMOND_WP:
        return BlackDiamondWPSpecificSettings()
      case IntegrationServiceId.E_MONEY:
        return EMoneySpecificSettings()
      case IntegrationServiceId.RIGHT_CAPITAL:
        return RightCapitalSpecificSettings()
      case IntegrationServiceId.WEALTH:
        return WealthSpecificSettings()
      case IntegrationServiceId.ZOOM:
        return zoomSections
      case IntegrationServiceId.PHONE:
        return PhoneSpecificSettings()
      case IntegrationServiceId.RINGCENTRAL:
        return RingCentralSpecificSettings()
      case IntegrationServiceId.GOTO:
        return GoToSpecificSettings()
      case IntegrationServiceId.DELEGATED_EMAIL:
        return DelegatedEmailSpecificSettings()
      case IntegrationServiceId.SCHWAB:
        return SchwabSpecificSettings()
      // case IntegrationServiceId.BOX:
      //   return BoxSpecificSettings()
      default:
        return []
    }
  }, [serviceId, zoomSections])
}
